import { PropsWithChildren } from 'react';

type StepperProps = PropsWithChildren

export const Stepper = ({ children }: StepperProps) => {
    return (
        <ol className="flex items-center justify-around w-full">
            {children}
        </ol>
    );
};
